// 反馈
import { FC, useRef, Ref } from 'react';
import { useMethods } from '@lhb/hook';
import FeedbackModal from './Modal';
import IconFont from 'src/common/components/IconFont/index';
import styles from './index.module.less';
import { Button } from 'antd';

const Feedback:FC<{title:string}> = ({ title = '' }) => {
  const feedbackModalRef:Ref<any> = useRef();

  const methods = useMethods({
    openFeedback() {
      feedbackModalRef.current?.init();
    },
  });

  return (<>
    <div className={styles.feedbackButton} onClick={() => methods.openFeedback()}>
      <Button
        shape='circle'
        icon={<IconFont iconHref='icon-ic_fankui' style={{ fontSize: '28px' }} />}
      />
    </div>
    <FeedbackModal title={title} ref={feedbackModalRef}/>
  </>);
};

export default Feedback;
